"use client"

import { FC } from "react"
import { FileText } from 'lucide-react'
import Contact from 'src/components/ContactForm/Contact'
import Form from 'src/components/ContactForm/Form'
import { useLanguage } from "@/src/context/LanguageContext"
import { useUI } from "@/src/lib/i18n/ui"

const ContactForm: FC = () => {
  const { lang } = useLanguage()
  const t = useUI(lang)

  return (
    <section id="contact" className="py-4 lg:py-4 bg-gradient-to-b from-[#111216] via-[#181b20] to-[#1e2126]" aria-labelledby="contact-title">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <FileText className="w-8 h-8 text-white mr-3" />
            <h2 id="contact-title" className="text-3xl lg:text-4xl font-semibold text-white">
              {t("contactFormTitle")}
            </h2>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 gap-12">
          <Form />
          <Contact />
        </div>
      </div>
    </section>
  )
}

export default ContactForm
